import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Button } from "react-bootstrap"
import { FaHistory, FaPlus, FaPencilAlt } from 'react-icons/fa'
import $ from 'jquery';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import Loader from "./Loader";

import AddIntegrationTemplate from './AddIntegrationTemplate';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import N from '../lib/Network';
import S from '../lib/Security';
var CryptoJS = require("crypto-js");

const Integration = () => {
    const [showTemplate, setShowTemplate] = useState(false);
    useEffect(() => {
        //getKeys();
        //fetchdatatableData();
        //initialize datatable
        setTimeout(function () {
            $('#viewIntegrationTemplate').DataTable({
                pagingType: 'full_numbers',
                pageLength: 7,
                processing: true,
                dom: 'Bfrtip',
                "columns":[  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    { 'searchable': true },  
                    {},
                    {},
                    {},
                    {},
                    {},
                    {},
                ],
                language: { search: "", searchPlaceholder: "Search By Template Code, Name, Sub Process, Company, Status "},
                buttons: [
                    {
                        text: '<i class="fa fa-file-excel-o" />',
                        className: 'custom-btn',
                        extend: 'csv'
                    }
                ],
                bDestroy: true,
                "initComplete": function() {
                    $(this).show();
                }
            });
        }, 1400 );
    }, []);
    
    {/*function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
    }*/}
    const openPreviewModalHandler = () => {
        setShowTemplate(true)
    }
    // const showLoaderPopup = () => {
    //     setShowLoader(true)
    // }
    // const closeLoader = () => {
    //     setShowLoader(false)
    // }
    const closePopup = () => { 
        setShowTemplate(false)
    }
    // const closeEditPopup = () => {
    //     setShowUserPopupEdit(false)
    // }
    // const handleEdit =(oldData)=>{
    //     setOldRecord({oldData})
    //     setShowUserPopupEdit(true);
    // }
        return (
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="wrapper">
                    {<Sidebar />}
                    {<Topbar />}
                    {/* <!-- End of Topbar --> */}
                    {/* <!-- Main Content --> */}
                    <div id="content">
                        {/* <!-- Begin Page Content --> */}
                        <Container fluid>
                            <Row>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 mb-2 mt-2">
                                    <div className="card dash-data-card">
                                        <div className="card-header pl-4 pr-4">
                                            <h5 className="headerTitle float-left mt-1">Manage Integration Templates</h5>
                                            <Button variant='light' type="button" className="btn btn-sm shadow-sm float-right ml-2" title="Audit Log">
                                                <FaHistory className="fas fa-plus" />
                                            </Button>
                                            <Button type="button" className="btn btn-sm btn-primary shadow-sm float-right" onClick={openPreviewModalHandler}>
                                                <FaPlus className="fas fa-plus pr-1" /><b style={{verticalAlign: 'middle'}}>Create Template</b>
                                            </Button>
                                            {/*{(localStorage.getItem("isCreateTenantRole")) ?
                                            <Button type="button" className="btn btn-sm btn-primary shadow-sm float-right" onClick={openPreviewModalHandler}>
                                                <FaPlus className="fas fa-plus pr-1" /><b style={{verticalAlign: 'middle'}}>Create Tenant</b>
                                            </Button>
                                            : null }*/}
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            <Row className="mb-3">
                                <Col lg='12'>
                                    <div className="card dash-data-card">
                                        <div className="card-body pl-4 pr-4">
                                            <table id="viewIntegrationTemplate" className="display">
                                                <thead>
                                                    <tr>
                                                        <th>Template Name</th>
                                                        <th>Process</th>
                                                        <th>Sub Process</th>
                                                        <th>Company Name</th>
                                                        <th>Template Status</th>
                                                        <th>Created By</th>
                                                        <th>Created On</th>
                                                        <th>Last Modified By</th>
                                                        <th>Last Modified On</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                        <tr>
                                                            <td>Template 1</td>
                                                            <td>Vendor Advance</td>
                                                            <td>Vendor Advance</td>
                                                            <td>Expenzing</td>
                                                            <td>Active</td>
                                                            <td>Power User</td>
                                                            <td>2022-06-01 11:51:47.0</td>
                                                            <td>Power User</td>
                                                            <td>2022-06-06 13:42:17.0</td>
                                                            <td>
                                                            <Button variant='light' className='btn-sm' ><FaPencilAlt /></Button>
                                                            {/* <Button variant='danger' className='btn-sm'>Delete </Button>  */}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Template 2</td>
                                                            <td>Asset</td>
                                                            <td>Asset</td>
                                                            <td>Expenzing</td>
                                                            <td>Active</td>
                                                            <td>Power User</td>
                                                            <td>2022-06-02 11:51:47.0</td>
                                                            <td>Power User</td>
                                                            <td>2022-06-08 13:42:17.0</td>
                                                            <td>
                                                            <Button variant='light' className='btn-sm' ><FaPencilAlt /></Button>
                                                            {/* <Button variant='danger' className='btn-sm'>Delete </Button>  */}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Template 3</td>
                                                            <td>Invoive</td>
                                                            <td>Invoive</td>
                                                            <td>Expenzing</td>
                                                            <td>Active</td>
                                                            <td>Power User</td>
                                                            <td>2022-06-03 11:51:47.0</td>
                                                            <td>Power User</td>
                                                            <td>2022-06-20 13:42:17.0</td>
                                                            <td>
                                                            <Button variant='light' className='btn-sm' ><FaPencilAlt /></Button>
                                                            {/* <Button variant='danger' className='btn-sm'>Delete </Button>  */}
                                                            </td>
                                                        </tr>
                                                </tbody>
                                            </table>
                                         </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        
                        <AddIntegrationTemplate showTemplate={showTemplate} closeModal={closePopup}/>
                        {/* <!-- /.container-fluid --> */}
                    </div>
                    {/* <!-- End of Main Content --> */}
                </div>
                {/* <!-- End of Content Wrapper --> */}
            </div>
            /* <!-- End of Page Wrapper --> */   
        )
    }
export default Integration;